// extracted by mini-css-extract-plugin
module.exports = {"statusCode":"_2R9xNRAset6keWNz_tdcTm","list":"_2moCCSj9OlfiNBjeJPIZfn"};